module.exports = __webpack_public_path__ + "static/media/pexels-dimitri-c-7102661.e77c0437.jpg";